import LocaleMapper from 'utils/LocaleMapper';
import viewerUserPreferences from 'models/user/ViewerUserPreferences';

var HowToSyncLinkBuilder = {
    getHowToSyncURL: function() {
        return '/modern/activity-sync';
    }
};

export default HowToSyncLinkBuilder;
